import r from"./eq.js";function t(t,e){for(var f=t.length;f--;)if(r(t[f][0],e))return f;return-1}export{t as default};
//# sourceMappingURL=_assocIndexOf.js.map
